import { CSSObject } from '@emotion/react';
import { Property } from 'csstype';

/**
 * This psuedo element makes sure the dimensions of the text/link is constant, even when changing font-weight
 * Supply content as an argument
 *
 * @example
 * export const StyledRawLink = styled.a<{content?: string}>(({ content }) => ({
 *    textDecoration: 'none',
 *    ...preserveFontSize(content)
 * }));
 *
 */
export const preserveFontSize = (
    content?: string,
    targetWeights: [Property.FontWeight, Property.FontWeight] = ['normal', 'bold']
): CSSObject => ({
    // In some cases the lesser weight is actually narrower than the larger,
    // so we must add a psuedo element for each weight
    ['&:before, &:after']: {
        display: 'block',
        content: `"${content}"`,
        fontFamily: 'inherit',
        height: '1px',
        color: 'transparent',
        overflow: 'hidden',
        visibility: 'hidden',
    },
    '&:before': {
        fontWeight: targetWeights[0],
    },
    '&:after': {
        fontWeight: targetWeights[1],
    },
});
